/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Language_SelectInputs */

const en_control_language_select = /** @type {(inputs: Control_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch language`)
};

const zh_control_language_select = /** @type {(inputs: Control_Language_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换语言`)
};

/**
* | output |
* | --- |
* | "Switch language" |
*
* @param {Control_Language_SelectInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_language_select = /** @type {((inputs?: Control_Language_SelectInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Language_SelectInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_language_select(inputs)
	return zh_control_language_select(inputs)
});
export { control_language_select as "control.language.select" }